<template>
  <div>
    <v-data-table
      :items="items"
      :headers="headers"
      hide-default-footer
      :items-per-page="20"
      class="ordera-box-shadow striped-table"
    >
      <template v-slot:header.name="{ header }">
        {{ translate(header.text) }}
      </template>
      <template v-slot:header.actions="{ header }">
        {{ translate(header.text) }}
      </template>
      <template v-slot:item.price="{ item }">
        {{ item.price }}
      </template>
      <template v-slot:item.actions="{ item }">
        <remove-button @click="$emit('removePrilog', item)"></remove-button>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  computed: {
    headers() {
      return [
        {
          text: "Id",
          align: "start",
          sortable: true,
          value: "id",
        },
        {
          text: this.$t("title"),
          align: "start",
          sortable: true,
          value: "name",
        },
        {
          text: this.$t("price"),
          value: "price",
          align: "start",
          sortable: true,
        },
        {
          text: this.$t("opt"),
          value: "actions",
          align: "end",
          sortable: false,
        },
      ];
    },
  },
};
</script>
